import { genericService } from "./genericService";

const section = "Cluster";

function list(params) {
  return genericService.get(section + "/ListPaginate/" + params + "/0/10");
}

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.get(section + "/ListPaginate/" + name + "/" + from + "/" + limit).then((response) => {
    return {
      list: response.clusters || [],
      quantity: response.clusters ? response.clusters.length : 0,
    };
  });
}

function getAll(params) {
  return genericService.get(section + "/ListCluster");
}

function create(item) {
  const param = {
    Name: item.name,
    IdCountry: item.country.id,
    Localities: item.localities.map(loc => loc.id),
  };
  return genericService.create(section, param);
}

function remove(id) {
  return genericService.remove(section, id);
}

function update(item) {
  const param = {
    id: item.id,
    Name: item.name,
    IdCountry: item.country.id,
    Localities: item.localities.map(loc => loc.id),
  };
  return genericService.update(section, param);
}

export const clusterService = {
  list,
  filter,
  getAll,
  create,
  update,
  remove,
};
